import { VideoOption } from '@openx/types/targeting/video';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useVideoTypeOptions = () => {
  const { t } = useTranslation();

  const labels = useMemo(
    () => ({
      [VideoOption.IN_STREAM_VIDEO_POSITION]: t('In-stream Video Position'),
      [VideoOption.MAX_AD_DURATION]: t('Maximum Ad Duration'),
      [VideoOption.PRESENTATION_FORMAT]: t('Presentation Formats'),
      [VideoOption.PLACEMENT]: t('Placement'),
      [VideoOption.REWARDED_VIDEO]: t('Rewarded Video'),
      [VideoOption.VIDEO_SKIPABILITY]: t('Video Skippability'),
    }),
    [t]
  );

  const options = Object.keys(labels) as VideoOption[];

  return {
    labels,
    options,
    getOptionLabel: (option: VideoOption) => labels[option],
  };
};
